export const FETCH_ALERT_REQUEST = "FETCH_ALERT_REQUEST";
export const FETCH_ALERT_SUCCESS = "FETCH_ALERT_SUCCESS";
export const FETCH_ALERT_FAILURE = "FETCH_ALERT_FAILURE";

export const FETCH_PURCHASED_USERS_REQUEST = "FETCH_PURCHASED_USERS_REQUEST";
export const FETCH_PURCHASED_USERS_SUCCESS = "FETCH_PURCHASED_USERS_SUCCESS";
export const FETCH_PURCHASED_USERS_FAILURE = "FETCH_PURCHASED_USERS_FAILURE";